<div id="container">
  <div [chart]="chart"></div>
</div>
